<template>
    
  <div class="check">
    <label>{{ $t(label) }} </label>
    <span v-if="hasError && error" class="badge-error" variant="none" :id="`${name}-error`">
      <small>{{ error }}</small>
    </span>
    <br>
    <span v-if="tooltip !==''" class="badge-info" variant="none"><small>{{ tooltip }}</small></span>
    <ul class="flex-list">
      <li v-for="opt in options" :key="opt.value">
    <input
        :name="name"
        :id="opt.name"
        :value="opt.value"
        v-model="selectedValues"
        v-bind="$attrs"
        :class="{
          'error': hasError,
          'green': !!value && !hasError
        }"
        :aria-describedby="`${name}-error`"
        v-on="{
          ...$listeners,
          input: event => updateInput ()
        }"
    ><span class="option-label">{{ opt.label }}</span>
    </li>
      </ul>
    <!-- <p :id="`${name}-error`" class="error" v-if="hasError && error">{{ error }}</p> -->
  </div>

</template>

<script>
export default {
  inheritAttrs: false,
  props: {
    value: {
      type: [String, Number, Array]
    },
    name: {
      type: String,
      required: true
    },
    label: {
      type: String,
      required: true
    },
    tooltip: {
      type: String,
      required: false
    },
    options: {
      type: Array,
      required: true,
      validator (opts) {
        return (
          opts.find(opt => {
            return !('label' in opt) || !('value' in opt)
          }) === undefined
        )
      }
    },
    error: {
      type: String,
      required: false
    },
    hasError: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      selectedValues: []
    }
  },
  watch: {
    selectedValues () {
      this.$emit('input', this.selectedValues)
    }
  },
  methods: {
    updateInput () {
      //No hace nada, el emit lo dispara el watch
    }
  }
}
</script>

<style scoped>
input {
  height: auto;
}
.check {
  text-align: center;
  margin-top: 25px;
  margin-bottom: 10px;
  width: 100%;
  /* padding: 0.375rem 0.75rem; */
  /* font-size: 1rem; */
  /* line-height: 1.5; */
  /* color: #495057; */
  /* background-color: #fff; */
  background-clip: padding-box;
  /* border: 1px solid #ced4da; */
  /* border-radius: 0.25rem; */
  transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
}
/* check {
  border-radius: 25px;
  height: 55px;
  line-height: 1.15;
  font-size: 16px;
  border: none;
  padding: 0 15px;
  color: #696A87;
  background: #f8f8f8;
  margin-bottom:10px;
} */
@media screen and (max-width: 479px) {
 check {
    width: 85%;
  }
}
.check.error {
  border-color: #721c24;
  border-width: 3px;
}
p.error {
  color: #721c24;
}
.check.green {
  border-color: green;
  border-width: 2px;
}
.badge-info {
  margin-top: 5px; 
  display: inline-block;
  border-radius: 10px;
  padding: 0 5px;
  color: var(--iq-primary-light);
	/* color: #fff; */
	/* background-color: #97b4b8 */
  background-color: whitesmoke
}
a.badge-info:focus,
a.badge-info:hover {
	color: #fff;
	background-color: #117a8b
}
a.badge-info.focus,
a.badge-info:focus {
	outline: 0;
	box-shadow: 0 0 0 .2rem rgba(23, 162, 184, .5)
}
.flex-list {
    justify-content:space-evenly;
    margin-block-start: 5px;
    margin-block-end: 10px;
    margin-inline-start: 0px;
    margin-inline-end: 0px;
    padding-inline-start: 0px;
    display: flex;
    columns: 3; /* Puedes ajustar el número de columnas según tus necesidades */
    list-style-type: none;
    flex-wrap: wrap;
    /* Puedes ajustar la propiedad flex-basis para cambiar el ancho de cada columna */
    flex-basis: auto;
  }
.flex-list li {
    /* flex: 1; */
    /* Esto asegura que cada elemento ocupe el mismo espacio en la columna */
    margin: 5px;
    /* Añade un margen entre los elementos para mejorar la apariencia */
  }
.option-label {
  line-height: 1.15;
  font-size: 16px;
  color: #2c3e50;
}
</style>
